module.exports = __webpack_public_path__ + "img/painPerceptionScale_10.bb69b305.png";